import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { Raw, Repository } from 'typeorm';
import { PostFilesEntity } from './post-files.entity';

@Injectable()
export class PostFilesService {
    constructor (
        @InjectRepository(PostFilesEntity)
        private postFilesRepository: Repository<PostFilesEntity>
    ){}

    async createPostAttachments(filesData) {
        try {
            const savedPostfiles = await this.postFilesRepository.save(filesData);
            if(savedPostfiles) {
                return true;
            } else { 
                return null;
            }
        } catch (error) {
            throw error;
        }
    }

    async getPostFiles(postId,ftype) {
        try {
            const data = await this.postFilesRepository.find({
                where:{postId:postId,status:true,fileType: Raw(alias => `UPPER(file_type) = '${ftype.toLocaleUpperCase()}'`)}
            })
            if(data) {
                return data;
            } else {
                return null;
            }
        } catch (error) {
            throw error;
        }
    }
}
